import { AddIcon, Button, Grid, GridRow } from '@bp/ui-components';
import { FieldArray, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import { CurriculaTableDataType, CurriculumClassType } from '../../types';
import { CurriculumClassesFormItem } from './CurriculumClassesFormItem';

type CurriculumClassesFormProps = {
  enableGroups: boolean;
  selectableGrades: number[];
};

export const CurriculumClassesForm = ({ enableGroups, selectableGrades }: CurriculumClassesFormProps) => {
  const { t } = useTranslation();

  // Curriculum -> curriculumGrades contain CurriculumClasses
  const { values } = useFormikContext<CurriculaTableDataType>();

  return (
    <FieldArray name={'curriculumGrades'}>
      {(arrayHelpers) => {
        return (
          <Grid useFormGap>
            {values.curriculumGrades?.map((curriculumClass, index) => {
              return (
                <CurriculumClassesFormItem
                  key={curriculumClass.uuid}
                  index={index}
                  multiEnabled={(values.curriculumGrades ?? []).length < 2}
                  curriculumClass={(values.curriculumGrades ?? [])[index]}
                  disabled={false}
                  enableGroups={enableGroups}
                  selectableGrades={selectableGrades}
                  onDelete={() => arrayHelpers.remove(index)}
                />
              );
            })}
            <GridRow spacingTop='none' spacingBottom='none'>
              <Button
                hierarchy='tertiary'
                icon={<AddIcon />}
                disabled={
                  values.curriculumGrades &&
                  !values.curriculumGrades?.every(
                    (cg) =>
                      !!cg.grades?.length &&
                      (cg.grades?.length ?? 0) < 2 &&
                      (cg.gradeGroups?.length ?? 0) < 2 &&
                      (cg.groups?.length ?? 0) < 2,
                  )
                }
                onClick={async () => {
                  const curriculumClass: CurriculumClassType = {
                    uuid: v4(),
                    grades: [],
                  };
                  arrayHelpers.push(curriculumClass);
                }}
              >
                {t('classes.createClass')}
              </Button>
            </GridRow>
          </Grid>
        );
      }}
    </FieldArray>
  );
};
